import { Injectable, OnInit } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { getApps, initializeApp, FirebaseApp } from 'firebase/app';
import { getMessaging, Messaging, getToken, onMessage } from 'firebase/messaging';
import { Constant } from "../constant";
import { MessageModel } from "../models/message.model";

@Injectable({
    providedIn: "root"
})
export class MessagingService {

    private appFirebase!: FirebaseApp;
    public messaging!: Messaging;
    public currentMessages = new BehaviorSubject<Array<MessageModel>>([]);

    constructor(
        private readonly constant: Constant
    ) {
        try {
            const apps = getApps();

            if (apps.length <= 0) {
                this.appFirebase = initializeApp(this.constant.firebaseConfig);
            } else {
                this.appFirebase = apps[0];
            }
            
            this.messaging = getMessaging(this.appFirebase);

        } catch (e) {
            console.log(e);
        }
    }

    public requestPermission(): Promise<string> {
        return new Promise(async (resolve, reject) => {
            try {
                const permis = await Notification.requestPermission();

                if (permis === "granted") {
                    const tokenFirebase = await getToken(this.messaging, { vapidKey: this.constant.vapidKeyFirebase });

                    resolve(tokenFirebase);
                } else {
                    reject(new Error('Permisos denegados'));
                }
            } catch(e: any) {
                reject(new Error(e.message));
            }
        });
    }

    private messaginObservable = new Observable(observe => {
        onMessage(this.messaging, payload => {
            observe.next(payload);
        });
    });

    public receiveMessage(): Observable<any> {
        return this.messaginObservable;
    }

    public addMessage(message: MessageModel): void {
        const messages = this.currentMessages.value as Array<MessageModel>;
        messages.push(message);

        this.currentMessages.next(messages);
    }
}